import type { IconProps } from "../types";

export const Compass = ({
  size = 24,
  strokeWidth = 2,
  absoluteStrokeWidth,
  ...props
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="butt"
    strokeLinejoin="miter"
    {...props}
  >
    <circle cx="12" cy="12" r="10" />
    <path d="m16.24 7.76-1.804 5.411-5.411 1.804 1.804-5.411z" />
  </svg>
);
